/* eslint-disable max-lines */
import { BORDER_ORANGE, COLOR1, COLOR4, RADIO_COLOR, COLOR2, COLOR5 } from '../../constants';
import Border from '../../images/border.svg';

export const SidebarStyles = {
  top_text_upload_id: {
    font: 'normal 700 14px/18px Arial !important',
    textAlign: 'left',
    letterSpacing: '0.12px',
    color: '#444444',
    opacity: 1,
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0px !important',
    whiteSpace: 'nowrap',
    paddingBottom: '4px',
    '@media (max-width: 650px)': {
      font: 'normal 700 14px/18px Arial',
      marginBottom: '8px',
      letterSpacing: '0.12px',
      color: '#444444',
      opacity: 0.8,
    },
    '@media (max-width: 660px)': {
      opacity: 1,
      marginBottom: '10px',
    },
    '@media (max-width: 400px)': {
      font: 'normal 700 13px/18px Arial !important',
    },
  },
  uploadIcon: {
    width: '42.67px',
    height: '45.33px',
  },
  idUpload_button: {
    border: `1px solid #661C69`,
    borderRadius: '25px',
    opacity: 1,
    maxWidth: '230px',
    maxHeight: '36px',
    margin: '0px 0px 33px 0px',
    font: 'normal 700 16px/19px Arial',
    backgroundColor: '#F3F3F3',
    padding: '10px 20px',
    color: `#661C69 !important`,
    textTransform: 'none',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: '#F3F3F3',
    },
    '&:focus': {
      outline: `2px solid ${RADIO_COLOR}`,
      outlineOffset: '2px',
    },
    '@media (max-width: 600px)': {
      width: '100%',
    },
    '@media (min-width: 960px) and (max-width: 1100px)': {
      padding: '10px',
    },
    '@media (min-width: 1100px)': {
      width: '90%',
    },
  },
  iconSize: {
    width: '64px',
    height: '64px',
  },
  uploadIdText: {
    marginBottom: '20px',
    font: 'normal normal 400 14px Arial',
    color: '#444444',
    paddingLeft: '20px',
    paddingRight: '20px',
    textAlign: 'center',
  },
  idUploadInitial: {
    boxSizing: 'border-box',
    paddingTop: '38px',
    height: '100%',
    border: '1px dashed #808285',
    borderRadius: '6px',
    '@media (max-width: 600px)': {
      width: '100%',
      maxWidth: '100%',
    },
  },
  '@media (min-width: 960px) and (max-width: 1024px)': {
    maxWidth: '287px',
    height: '220px',
    marginRight: '200px',
  },
  business_top_text_upload_id: {
    font: 'normal 700 14px/18px Arial !important',
  },
  statement_top_txt: {
    display: 'inline-block',
    width: '160px',
  },
  margin_left: {
    marginRight: '10px',
  },
  title: {
    color: BORDER_ORANGE,
    textAlign: 'center',
    font: 'normal normal normal 18px/21px Arial',
    letterSpacing: '0.12px',
    marginBottom: '10px',
    opacity: 1,
    '@media (max-width: 650px)': {
      font: 'normal normal 300 14px/17px Arial',
      letterSpacing: '0.10px',
      marginBottom: '10px',
      color: BORDER_ORANGE,
      textAlign: 'center',
    },
  },
  idUpload_container: {
    '@media (max-width: 960px)': {
      marginLeft: '20px',
      paddingLeft: '0',
    },
    '@media (max-width: 960px)': {
      marginTop: '20px',
      paddingLeft: '0',
    },
  },
  id_upload_grid: {
    display: 'flex',
    justifyContent: 'center',
    '@media (max-width: 600px)': {
      display: 'block',
    },
  },
  id_upload_grid_error: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
  },
  dotted_border: {
    backgroundImage: `url(${Border})`,
    width: '218px',
    height: '213px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: RADIO_COLOR,
    '@media (max-width: 650px)': {
      width: '193px',
      height: '156px',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: RADIO_COLOR,
    },
  },
  done_dotted_border: {
    backgroundImage: `url(${Border})`,
    width: '218px',
    height: '178px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: RADIO_COLOR,
    '@media (max-width: 650px)': {
      width: '193px',
      height: '156px',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: RADIO_COLOR,
    },
  },
  image_border: {
    width: '218px',
    height: '214px',
  },
  done_image_border: {
    width: '218px',
    height: '214px',
  },
  error_icon: {
    width: '218px',
    height: '214px',
    cursor: 'pointer',
    '&:focus': {
      outline: 'none !important',
      borderColor: '#719ECE',
      boxShadow: '0 0 10px #719ECE',
    },
  },
  done_icon: {
    width: '218px',
    height: '214px',
  },
  upload_button_div: {
    display: 'block',
    textAlign: 'center',
  },
  camera_icon: {
    cursor: 'pointer',
    width: '218px',
    '@media (max-width: 350px)': {
      width: '180px',
    },
  },
  doc_icon: {
    cursor: 'pointer',
    width: '218px',
    height: '214px',
    '@media (max-width: 350px)': {
      width: '180px',
      height: '180px',
    },
    '&:focus': {
      outline: 'none !important',
      borderColor: '#719ECE',
      boxShadow: '0 0 10px #719ECE',
    },
  },
  status_icon: {
    maxWidth: '105px',
    maxHeight: '105px',
    width: '102px',
    height: '102px',
    '@media (max-width: 650px)': {
      maxWidth: '60px',
      maxHeight: '60px',
      width: '60px',
      height: '60px',
    },
  },
  cameraImgPositionOverlay: {
    position: 'relative',
    top: '17px',
    '@media (max-width: 650px)': {
      position: 'relative',
      top: '1px',
    },
  },
  cameraImgPosition: {
    position: 'relative',
    top: '18px',
    display: 'flex',
    justifyContent: 'center',
    '@media (max-width: 650px)': {
      top: '5px',
    },
  },
  errorImgPosition: {
    position: 'relative',
    top: 0,
    display: 'flex',
    justifyContent: 'center',
    '@media (max-width: 650px)': {
      top: 0,
    },
  },
  doneImgPosition: {
    position: 'relative',
    top: 0,
    display: 'flex',
    justifyContent: 'center',
    '@media (max-width: 650px)': {
      top: 0,
    },
  },
  btnPosition: {
    position: 'relative',
    top: '21px',
    '@media (max-width: 650px)': {
      top: '1px',
    },
  },
  errorBtnPosition: {
    position: 'relative',
    top: '33px',
    '@media (max-width: 650px)': {
      top: '13px',
    },
  },
  cameraImgPositionStatus: {
    position: 'relative',
    top: '15px',
    '@media (max-width: 650px)': {
      position: 'relative',
      top: '1px',
    },
  },
  doc_upload_status: {
    maxWidth: '59px',
    maxHeight: '59px',
    width: '59px',
    height: '59px',
    '@media (max-width: 650px)': {
      maxWidth: '60px',
      maxHeight: '60px',
      width: '60px',
      height: '60px',
    },
  },
  id_text_below_camera: {
    font: 'normal normal bold 15px/17px Arial',
    textAlign: 'center',
    opacity: 1,
    '@media (max-width: 650px)': {
      font: 'normal normal bold 15px/17px Arial',
      textAlign: 'center',
      opacity: 1,
    },
  },
  busiAccWidth: {
    '@media (min-width: 600px) and (max-width: 960px)': {
      width: '80%',
    },
  },
  busiAccWidth_box: {
    '@media (min-width: 600px) and (max-width: 960px)': {
      maxWidth: '100% !important',
    },
  },
  imgUploadId: {
    marginTop: '30px',
    marginBottom: '23px',
    '@media (max-width: 1200px)': {
      margin: '20px 0px',
    },
  },
  uploadContainerID: {
    maxHeight: '100%',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    border: '1px dashed #808285',
    cursor: 'pointer',
    background: '#F3F3F3',
    '&:focus': {
      backgroundImage:
        'repeating-linear-gradient(0deg,blue,blue 7px,transparent 8px,transparent 15px), repeating-linear-gradient(90deg,blue,blue 7px,transparent 8px,transparent 15px), repeating-linear-gradient(180deg,blue,blue 7px,transparent 8px,transparent 15px), repeating-linear-gradient(270deg,blue,blue 7px,transparent 8px,transparent 15px)',
      borderImage:
        'repeating-linear-gradient(0deg, blue, blue 1px, transparent 1px, transparent 1px)',
    },
  },
  uploadContainer: {
    position: 'relative',
    height: '41px',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  box: {
    width: '100%',
    height: '61px',
    fontSize: '14px',
    lineHeight: 1,
    borderRadius: '4px',
    backgroundPosition: '0 0, 0 0, 100% 0, 0 100%',
    backgroundSize: '1px 100%, 100% 1px, 1px 100%, 100% 1px',
    backgroundRepeat: 'no-repeat',
  },
  box_a: {
    WebkitTapHighlightColor: 'transparent',
    borderRadius: '7px',
    width: '100%',
    height: 'fit-content',
    // paddingTop: '30px',
    // paddingBottom: '30px',
    backgroundImage:
      'repeating-linear-gradient(0deg,#808285,#808285 7px,transparent 8px,transparent 15px), repeating-linear-gradient(90deg,#808285,#808285 7px,transparent 8px,transparent 15px), repeating-linear-gradient(180deg,#808285,#808285 7px,transparent 8px,transparent 15px), repeating-linear-gradient(270deg,#808285,#808285 7px,transparent 8px,transparent 15px)',
    borderImage:
      'repeating-linear-gradient(0deg, #808285, #808285 1px, transparent 1px, transparent 1px)',
    '@media (max-width: 600px)': {
      maxWidth: '100%',
    },
  },
  boxID: {
    width: '100%',
    fontSize: '14px',
    lineHeight: 1,
    borderRadius: '4px',
    backgroundPosition: '0 0, 0 0, 100% 0, 0 100%',
    backgroundSize: '1px 100%, 100% 1px, 1px 100%, 100% 1px',
    backgroundRepeat: 'no-repeat',
  },
  box_aID: {
    WebkitTapHighlightColor: 'transparent',
    borderRadius: '7px',
    width: '100%',
    backgroundImage:
      'repeating-linear-gradient(0deg,#808285,#808285 7px,transparent 8px,transparent 15px), repeating-linear-gradient(90deg,#808285,#808285 7px,transparent 8px,transparent 15px), repeating-linear-gradient(180deg,#808285,#808285 7px,transparent 8px,transparent 15px), repeating-linear-gradient(270deg,#808285,#808285 7px,transparent 8px,transparent 15px)',
    borderImage:
      'repeating-linear-gradient(0deg, #808285, #808285 1px, transparent 1px, transparent 1px)',
    '@media (max-width: 600px)': {
      maxWidth: '100%',
    },
  },
  supportedText: {
    font: 'normal 400 12px/14px Arial',
    color: '#727578',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '9px',
  },
  supportedTextErr: {
    font: 'normal 400 12px/14px Arial',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '9px',
    color: '#D71721',
  },
  support_text1: {
    '@media (max-width: 600px)': {
      display: 'block',
      paddingBottom: '7px',
    },
  },
  uploadSecondaryContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    // paddingLeft: '30px',
    // paddingRight: '30px',
    padding: '30px',
    '@media (max-width: 601px)': {
      paddingLeft: '30px',
      paddingRight: '30px',
      width: '100%',
    },
  },
  docTypeSelect: {
    margin: '20px 0px',
    background: '#FFFFFF',
    border: '1px solid #D0D0D0',
    maxWidth: '182px',
    borderRadius: '0px',
    height: '36px',
    font: 'normal 700 16px/20px Arial',
    color: '#727578',
    '@media (max-width: 601px)': {
      margin: '10px 0px',
    },
  },
  select_outlined: {
    padding: '0px 15px',
  },
  select_icon: {
    color: COLOR5,
  },
  select_iconOutlined: {
    right: '17px',
  },
  upload_icon_button: {
    textTransform: 'none',
    borderRadius: '56px',
    width: '124px',
    height: '36px',
    font: 'normal 700 16px/20px Arial',
    '@media (max-width: 959px) and (min-width: 601px)': {
      width: '100px',
    },
    '@media (max-width: 601px)': {
      width: '100%',
    },
    '&:focus': {
      outline: `2px solid ${RADIO_COLOR}`,
      outlineOffset: '2px',
    },
  },
  doneText: {
    font: 'normal 400 20px/18px Arial',
    color: '#E37617',
    marginTop: '15px',
  },
  doneTextBundle: {
    font: 'normal 400 20px/18px Arial',
    color: '#0B6C03',
    fontWeight: '700',
    marginTop: '15px',
  },
  errorText: {
    font: 'normal 400 20px/18px Arial',
    color: '#D71721',
    marginTop: '15px',
    lineHeight: 'normal',
  },
  errorTextBundle: {
    font: 'normal 400 14px Arial',
    color: '#D71721',

    // margin: '15px 15px 0 15px',
  },
  statusContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '30px',
  },
  statusContainerAcc: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '50px 0',
  },
  cameraBtn: {
    marginRight: '20px',
    '@media (max-width: 601px)': {
      marginRight: '0px',
      marginBottom: '0px',
    },
  },
  btn_container: {
    '@media (max-width: 601px)': {
      width: '90%',
      marginRight: '10px',
      marginLeft: '10px',
    },
  },
  btn_grid_container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (max-width: 601px)': {
      flexDirection: 'unset',
      width: '100%',
      marginTop: '20px',
    },
  },
  documentImgPositionForStatus: {
    position: 'relative',
    top: '30px',
    '@media (max-width: 650px)': {
      position: 'relative',
      top: '2px',
    },
  },
  imgInfoPosition: {
    position: 'relative',
    top: '1px',
    '@media (max-width: 650px)': {
      position: 'relative',
      top: '-27px',
    },
  },
  imgInfoPositionOverlay: {
    position: 'relative',
    top: '1px',
    '@media (max-width: 650px)': {
      position: 'relative',
      top: '-26px',
    },
  },
  imgDocInfoPosition: {
    position: 'relative',
    top: '15px',
    '@media (max-width: 650px)': {
      position: 'relative',
      top: '-27px',
    },
  },
  btnPositionOverlay: {
    position: 'relative',
    top: '21px',
    '@media (max-width: 650px)': {
      position: 'relative',
      top: '-3px',
    },
  },
  btnDocPosition: {
    position: 'relative',
    top: '30px',
    '@media (max-width: 650px)': {
      position: 'relative',
      top: '-2px',
    },
  },
  btnDocPositionForStatus: {
    position: 'relative',
    top: '56px',
    '@media (max-width: 650px)': {
      position: 'relative',
      top: '3px',
    },
  },
  btnDocPositionForStatus: {
    position: 'relative',
    top: '41px',
    '@media (max-width: 650px)': {
      position: 'relative',
      top: '3px',
    },
  },

  id_upload_button: {
    backgroundColor: RADIO_COLOR,
    color: COLOR4,
    width: '194px',
    height: '45px',
    font: 'normal normal normal 18px/21px Arial',
    textTransform: 'none',
    borderRadius: '7px',
    letterSpacing: '0.12px',
    border: `0.5px solid ${RADIO_COLOR}`,
    '&:hover': {
      backgroundColor: RADIO_COLOR,
    },
    opacity: 1,
    '@media (max-width: 650px)': {
      width: '165px',
      height: '38px',
      font: 'normal normal normal 17px/21px Arial',
      backgroundColor: RADIO_COLOR,
      color: COLOR4,
      textTransform: 'none',
    },
  },
  disabled_button: {
    '&.MuiButton-root.Mui-disabled': {
      backgroundColor: RADIO_COLOR,
      color: COLOR4,
      width: '194px',
      height: '45px',
      font: 'normal normal normal 18px/21px Arial',
      textTransform: 'none',
      borderRadius: '7px',
      border: `0.5px solid ${RADIO_COLOR}`,
      '&:hover': {
        backgroundColor: RADIO_COLOR,
      },
      opacity: 1,
      '@media (max-width: 650px)': {
        width: '165px',
        height: '38px',
        font: 'normal normal normal 17px/21px Arial',
        backgroundColor: RADIO_COLOR,
        color: COLOR4,
        textTransform: 'none',
      },
    },
  },
  upload_image_container: {
    width: '185px',
    height: '196px',
    display: 'inline-block',
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
    '@media (max-width: 650px)': {
      height: '83px',
      width: '165px',
      position: 'absolute',
      top: 0,
      display: 'inline-grid',
      padding: 'unset',
      textAlign: 'unset',
      border: `1px solid ${RADIO_COLOR}`,
    },
  },
  id_upload_image_container: {
    width: '185px',
    height: '196px',
    position: 'absolute',
    top: 0,
    display: 'inline-grid',
    justifyContent: 'center',
    alignItems: 'center',
    '@media (max-width: 650px)': {
      height: '83px',
      width: '165px',
    },
  },
  upload_camera_style: {
    marginBottom: '15px',
    width: '135px',
    '@media (max-width: 650px)': {
      marginBottom: 'unset',
      width: 'unset',
    },
  },
  upload_status_icon: {
    maxWidth: '185px',
    maxHeight: '196px',
    marginBottom: '-6px',
    '@media (max-width: 650px)': {
      maxHeight: '50px',
      maxWidth: '50px',
    },
  },
  id_image: {
    position: 'absolute',
    height: '40px',
    top: '83px',
    left: '106px',
    '@media (max-width: 650px)': {
      height: 'unset',
      maxWidth: '25px',
      maxHeight: '25px',
      top: '43px',
      left: '90px',
    },
  },
  text_below_camera: {
    position: 'relative',
    display: 'inline-block',
    top: '5px',
    font: 'normal normal normal 17px/21px Arial',
    opacity: 1,
    textAlign: 'center',
    color: RADIO_COLOR,
    width: '130px',
    '@media (max-width: 650px)': {
      font: 'normal normal normal 15px/17px Arial',
    },
  },
  upload_button_position: {
    position: 'absolute',
    bottom: 0,
    left: 0,
  },
  new_addr_gif_width_adjust: {
    '@media (max-width: 360px)': {
      width: '95%',
    },
  },
  up_arrow: {
    position: 'absolute',
    top: '85px',
    left: '75px',
    width: '30px',
    '@media (max-width: 650px)': {
      top: '39px',
      left: '67px',
      width: '23px',
    },
  },
  new_addr_gif: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    maxWidth: 'unset',
    '@media (min-width: 960px)': {
      maxWidth: '215px',
    },
  },
  text_display_none_below_650: {
    '@media (max-width: 650px)': {
      display: 'none',
    },
  },
  id_upload_consent: {
    margin: '20px 9px 0 8px',
    display: 'flex',
    justifyContent: 'center',
    width: '230px',
    font: 'normal normal normal 12px/14px Arial',
    letterSpacing: '0.1px',
    textAlign: 'left',
    '@media (max-width: 960px)': {
      margin: '20px 0 0 0',
      width: '100%',
    },
    '@media (max-width: 650px)': {
      display: 'none',
      width: '100%',
    },
  },
  hide_below_650: {
    '@media (max-width: 650px)': {
      display: 'none',
    },
  },
  image_upload_status_text: {
    textAlign: 'center',
    font: 'normal normal bold 14px/17px Arial',
    letterSpacing: '0.1px',
    color: COLOR1,
    position: 'relative',
    top: '35px',
    '@media (max-width: 650px)': {
      top: '30px',
    },
  },
  error_upload_status_text: {
    textAlign: 'center',
    font: 'normal normal bold 14px/17px Arial',
    letterSpacing: '0.1px',
    color: COLOR1,
    position: 'relative',
    top: '25px',
    '@media (max-width: 650px)': {
      top: '10px',
    },
  },
  doc_upload_status_text: {
    textAlign: 'center',
    font: 'normal normal bold 18px/21px Arial',
    letterSpacing: '0.12px',
    color: COLOR1,
    position: 'relative',
    top: '35px',
    '@media (max-width: 650px)': {
      top: '1px',
    },
  },
  tooltip_position_EN: {
    marginLeft: '-19px',
    opacity: 1,
  },
  tooltip_position_ES: {
    marginLeft: '-44px',
    opacity: 1,
  },
  ocrErrorStyle: {
    color: COLOR2,
    margin: '2px',
    display: 'block',
    textAlign: 'center',
    fontSize: '16px',
    maxWidth: 'fit-content',
  },
  errorStyle: {
    color: COLOR2,
    margin: '2px',
    display: 'block',
    textAlign: 'center',
    fontSize: '16px',
  },
  btn_grid_container_cdira: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 1,
    flexWrap: 'wrap',
    width: '100%',
  },
  upload_icon_buttonira: {
    textTransform: 'none',
    borderRadius: '56px',
    width: '124px',
    height: '36px',
    font: 'normal 700 16px/20px Arial',
    '&:focus': {
      outline: `2px solid ${RADIO_COLOR}`,
      outlineOffset: '2px',
    },
  },
  btn_grid_containerira: {
    gap: '12px',
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'end',
    flexShrink: '0',
    maxWidth: '260px',
  },
  docBtnStyles: {
    width: '100%',
    maxWidth: '141px',
    borderRadius: '56px',
    padding: '8px',
    font: 'normal 700 16px/20px Arial',
    textAlign: 'center',
    alignSelf: 'stretch',
    '&:focus': {
      outline: `2px solid ${RADIO_COLOR}`,
      outlineOffset: '2px',
    },
  },
};
